import { supabase } from './supabaseClient';

// Shared datastore for the pals' connected teams (Supabase `connections` table).
// See the Phase 2 plan for the schema and RLS policies.

const requireClient = () => {
  if (!supabase) {
    throw new Error(
      'Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.'
    );
  }
  return supabase;
};

// All connected teams for a given season, oldest first.
export const listConnections = async (season) => {
  const { data, error } = await requireClient()
    .from('connections')
    .select('*')
    .eq('season', season)
    .order('created_at', { ascending: true });
  if (error) throw error;
  return data;
};

// Add a pal's team. Keys map to the snake_case table columns.
export const addConnection = async ({
  palName,
  leagueId,
  leagueName,
  teamId,
  teamName,
  teamLogo,
  season,
}) => {
  const { data, error } = await requireClient()
    .from('connections')
    .insert({
      pal_name: palName,
      league_id: leagueId,
      league_name: leagueName,
      team_id: teamId,
      team_name: teamName,
      team_logo: teamLogo,
      season,
    })
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const removeConnection = async (id) => {
  const { error } = await requireClient().from('connections').delete().eq('id', id);
  if (error) throw error;
};
